import React from "react";
import { FiCheck } from "react-icons/fi";

const StepIndicator = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="w-full overflow-x-auto py-4 px-2">
      <div className="flex items-center justify-between min-w-[500px] md:min-w-0">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = step.isComplete;
          // Allow clicking completed steps, the current step, or the next step after the last completed
          const allPriorComplete = steps.slice(0, index).every((s) => s.isComplete);
          const isClickable = isCompleted || isActive || allPriorComplete;

          return (
            <React.Fragment key={stepNumber}>
              {/* Step circle + label */}
              <button
                onClick={() => isClickable && onStepClick(stepNumber)}
                className={`flex flex-col items-center gap-1.5 flex-shrink-0 ${
                  isClickable ? "cursor-pointer group" : "cursor-not-allowed opacity-60"
                }`}
                disabled={!isClickable}
              >
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-200 ${
                    isActive
                      ? "bg-primary-600 text-white ring-4 ring-primary-100"
                      : isCompleted
                      ? "bg-green-500 text-white"
                      : "bg-neutral-200 text-neutral-500"
                  } ${isClickable && !isActive ? "group-hover:ring-2 group-hover:ring-neutral-300" : ""}`}
                >
                  {isCompleted && !isActive ? (
                    <FiCheck className="w-4 h-4" />
                  ) : (
                    stepNumber
                  )}
                </div>
                <span
                  className={`text-xs font-medium hidden md:block transition-colors ${
                    isActive
                      ? "text-primary-700"
                      : isCompleted
                      ? "text-green-600"
                      : "text-neutral-400"
                  }`}
                >
                  {step.label}
                </span>
              </button>

              {/* Connector line */}
              {stepNumber < steps.length && (
                <div className="flex-1 mx-1.5">
                  <div
                    className={`h-0.5 rounded-full transition-colors ${
                      isCompleted ? "bg-green-400" : "bg-neutral-200"
                    }`}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
